import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import apiClient, { IMAGE_BASE_URL } from '../../utils/api-client';
import CategoriesListSkeleton from '../Common/CategoriesListSkeleton';
import './CategoriesList.css';
const CategoriesList = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    apiClient
      .get('/category')
      .then((res) => {
        setCategories(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setIsLoading(false);
      });
  }, []);
  return (
    <div className="row d-flex justify-content-center gap-3">
      {error && <em className="form_error">{error}</em>}
      {isLoading && <CategoriesListSkeleton cards={8} />}
      {categories.map((category, index) => (
        <div
          className="col-lg-1  col-md-2 col-4 px-2 py-1 pb-2 categories_list"
          key={index}
        >
          <NavLink
            to={`/category/${category.slug}/`}
            className="d-flex flex-column justify-content-center flex-direction-coloumn"
          >
            <img
              src={`${IMAGE_BASE_URL}/${category.pcat_image}`}
              alt={category.p_category_name}
              className="image-fluid mx-auto"
            />

            <h5
              className="text-truncate"
              style={{
                maxWidth: window.innerWidth > 578 ? '100px' : '80px',
              }}
            >
              {category.p_category_name}
            </h5>
          </NavLink>
        </div>
      ))}
    </div>
  );
};
export default CategoriesList;
